module.exports = __webpack_public_path__ + "img/aguarde_2.cfd5f2c2.gif";